export function renderErrorMessageLineLayoutTemplate({
  indent,
  pathExpression
}: {
  indent: string
  pathExpression: string
}): string {
  return `${indent}{getFieldErrorMessage(form.formState.errors, ${pathExpression}) ? (
${indent}  <p className="text-sm text-destructive">
${indent}    {getFieldErrorMessage(form.formState.errors, ${pathExpression})}
${indent}  </p>
${indent}) : null}`
}
